import { render, staticRenderFns } from "./summarize-modal.vue?vue&type=template&id=4bcceabf&scoped=true"
import script from "./summarize-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./summarize-modal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./summarize-modal.vue?vue&type=style&index=0&id=4bcceabf&prod&lang=scss"
import style1 from "./summarize-modal.vue?vue&type=style&index=1&id=4bcceabf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcceabf",
  null
  
)

export default component.exports